import { ValidatorRule, ValidatorResult } from './validatorRule.constants';
import { BaseValidator } from './baseValidator';
import { TranslationHelpers } from '../../../i18n/translationHelpers';

export class EmailFieldValidator extends BaseValidator {
    /**
     * EU side email validator
     * @param value
     */
    EUEmailRule(value: string): ValidatorResult {
        const PATTERN_EUEMAILRULE =
            /^[\u0021\u0023-\u0027\u002B\u002D-\u0039\u003D\u003F\u0041-\u005A\u005E-\u007E]+@[\u002D\u0030-\u0039\u0041-\u005A\u0061-\u007A]+(\.[\u002D\u0030-\u0039\u0041-\u005A\u0061-\u007A]+)+$/i;
        if (!PATTERN_EUEMAILRULE.test(value)) {
            return {
                value: value,
                message: TranslationHelpers.getMessageDescriptor('error.email.invalid'),
                rule: 'EUEmailRule',
            };
        }
        return null;
    }

    /**
     * JP side email validator
     * @param value
     */
    JPEmailRule(value: string): ValidatorResult {
        const PATTERN_JPEMAILRULE =
            /^[-_+#?/!$%&`=~^|A-Za-z0-9]+([-_+#?/!$%&`=~^|]*[.]{0,1}[A-Za-z0-9-_+#?/!$%&`=~^|])*@[A-Za-z0-9]+(-?[A-Za-z0-9]+)*(\.[A-Za-z0-9]+(-?[A-Za-z0-9])*)*(\.[A-Za-z]{2,})+$/g;
        if (!PATTERN_JPEMAILRULE.test(value)) {
            return {
                value: value,
                message: TranslationHelpers.getMessageDescriptor('error.email.invalid'),
                rule: 'JPEmailRule',
            };
        }
        return null;
    }

    EmailLengthRule(value: string) {
        const MAX_LENGTH = 100;
        const MIN_LENGTH = 6;
        if (value.length > MAX_LENGTH) {
            return {
                value: value,
                message: TranslationHelpers.getFormattedMessageProps('error.email.long', {
                    n: MAX_LENGTH,
                }),
                rule: 'EmailLengthRule',
            };
        } else if (value.length < MIN_LENGTH) {
            return {
                value: value,
                message: TranslationHelpers.getFormattedMessageProps('error.email.short', {
                    n: MIN_LENGTH,
                }),
                rule: 'EmailLengthRule',
            };
        }
        return null;
    }

    JPEmailLength100thRule(value: string) {
        const MAX_LENGTH = 100;
        if (value.length > MAX_LENGTH) {
            return {
                value: value,
                message: TranslationHelpers.getFormattedMessageProps('error.email.long', {
                    n: MAX_LENGTH,
                }),
                rule: 'JPEmailLength100thRule',
            };
        }
        return null;
    }

    constructor(rules = [ValidatorRule.EmailLengthRule, ValidatorRule.EUEmailRule]) {
        super(rules);
    }
}
